import React, { useCallback, useEffect, useState } from "react";
import AgentLayout from "../components/AgentLayout";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import UserNavigation from "../users/user-navigation";
import { useDispatch, useSelector } from "react-redux";
import DatePickerComponent from "../../client/components/DatePickerComponent";
import moment from "moment";
import { setLoader } from "../../../store/loaderSlice";
import { isMobile } from "react-device-detect";
import $ from "jquery";
import Bootstrap4DatePickerComponent from "../../client/components/Bootstrap4DatePickerComponent";

const AccountProfitLoss = () => {
  const [pageLoad, setPageLoad] = useState(false);
  const userInfo = useSelector((state) => state.userStore);

  const { userId } = useParams();

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const dispatch = useDispatch();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);

  const [profitLossList, setProfitLossList] = useState([]);
  const [cricektPL, setCricektPL] = useState(0);
  const [fancyPL, setFancyPL] = useState(0);
  const [soccerPL, setSoccerPL] = useState(0);
  const [tennisPL, setTennisPL] = useState(0);
  const [horseRacePL, setHorseRacePL] = useState(0);
  const [grayHoundPL, setGrayHoundPL] = useState(0);
  const [worldCasinoPL, setWorldCasinoPL] = useState(0);
  const [betfairGamesPL, setBetfairGamesPL] = useState(0);
  const [galexyStudioPL, setGalexyStudioPL] = useState(0);
  const [tpStudioPL, setTpStudioPL] = useState(0);
  const [grandTotalPL, setGrandTotalPL] = useState(0);
  const [displayUsername, setDisplayUsername] = useState("");
  const [userRole, setUserRole] = useState(0);

  const [displayEventName, setDisplayEventName] = useState("");

  const [displayPlPanel, setDisplayPlPanel] = useState(false);
  const [displayDetailsPanel, setDisplayDetailsPanel] = useState(false);

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  const getProfitLoss = useCallback(
    async (userId) => {
      try {
        setProfitLossList([]);
        setDisplayDetailsPanel(false);
        let resultObj = {};
        await dispatch(setLoader(true));

        let frm = toUtcBound(startDate);
        let til = toUtcBound(endDate);

        resultObj.fromdate = frm;
        resultObj.todate = til;
        resultObj.userId = userId;

        const response = await axiosInstance.post(
          "/master/profit-loss/profit-loss-by-user",
          resultObj
        );
        let results = response.data;
        if (results !== null && results !== undefined) {
          let returnObj = results.returnObj;

          setCricektPL(returnObj.cricket);
          setFancyPL(returnObj.fancy);
          setSoccerPL(returnObj.soccer);
          setTennisPL(returnObj.tennis);
          setHorseRacePL(returnObj.horseRace);
          setGrayHoundPL(returnObj.greyhound);
          setWorldCasinoPL(returnObj.worldCasino);
          setBetfairGamesPL(returnObj.betfairGames);
          setGalexyStudioPL(returnObj.galexyStudio);
          setTpStudioPL(returnObj.tpStudio);

          setGrandTotalPL(returnObj.grandTotal);

          await dispatch(setLoader(false));
          setDisplayPlPanel(true);
        } else {
          await dispatch(setLoader(false));
        }
      } catch (error) {
        await dispatch(setLoader(false));
      }
    },
    [startDate, endDate]
  );

  const setEventName = async (sportsType, marketId) => {
    if (sportsType == 1 && marketId == 3) {
      setDisplayEventName("Fancy");
    } else if (sportsType == 1) {
      setDisplayEventName("Cricket");
    } else if (sportsType == 2) {
      setDisplayEventName("Soccer");
    } else if (sportsType == 3) {
      setDisplayEventName("Tennis");
    } else if (sportsType == 4) {
      setDisplayEventName("Horse Race");
    } else if (sportsType == 5) {
      setDisplayEventName("Greyhound Race");
    } else if (sportsType == 6) {
      setDisplayEventName("Casino");
    } else if (sportsType == 7) {
      setDisplayEventName("TeenPatti Studio");
    } else if (sportsType == 9) {
      setDisplayEventName("Betfair Studio");
    } else if (sportsType == 10) {
      setDisplayEventName("Galaxy Studio");
    }
  };

  const getSportDetail = async (sportsType, marketId, userId) => {
    try {
      setEventName(sportsType, marketId);
      let frm = toUtcBound(startDate);
      let til = toUtcBound(endDate);

      await dispatch(setLoader(true));
      let resultObj = {};
      resultObj.sportsType = sportsType;
      resultObj.marketId = marketId;
      resultObj.fromdate = frm;
      resultObj.todate = til;
      resultObj.userId = userId;

      const response = await axiosInstance.post(
        "/master/profit-loss/pl-details",
        resultObj
      );
      let results = response.data;
      if (results !== null && results !== undefined) {
        setProfitLossList(results.list);
        await dispatch(setLoader(false));
        setDisplayDetailsPanel(true);
      } else {
        await dispatch(setLoader(false));
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  function toUtcBound(d) {
    return new Date(d).toISOString();
  }

  useEffect(() => {
    const fetchUserById = async () => {
      if (userId !== "") {
        let tt = userId;
        const response = await axiosInstance.get("user/" + userId);
        if (
          response !== "" &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setDisplayUsername(response.data?.uname);
          setUserRole(response.data?.user_role);
        }
        setPageLoad(true);
      }
    };
    fetchUserById();
  }, []);

  const openLedgerPopUp = async (id, game_type) => {
    let tt = userRole;

    if (userRole == 8) {
      if (game_type == 9) {
        const popup = window.open(
          "/client-virtual-details-view/" + id,
          "",
          "width=700,height=500"
        );
        if (popup) {
          popup.document.title = "BPEXCH";
        }
      } else if (game_type == 6) {
        const popup = window.open(
          "/client-casino-details-view/" + id,
          "",
          "width=700,height=500"
        );
        if (popup) {
          popup.document.title = "BPEXCH";
        }
      } else if (game_type == 7 || game_type == 10) {
        const popup = window.open(
          "/client-tp-details-view/" + id,
          "",
          "width=700,height=500"
        );
        if (popup) {
          popup.document.title = "BPEXCH";
        }
      } else {
        const popup = window.open(
          "/clinet-bet-details-view/" + id,
          "",
          "width=700,height=500"
        );
        if (popup) {
          popup.document.title = "BPEXCH";
        }
      }
    } else {
      const popup = window.open(
        "/plby-hierarchical/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    }

    /*if (game_type == 9) {
      const popup = window.open(
        "/client-virtual-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else {
      const popup = window.open(
        "/clinet-bet-details-view/" + id,
        "",
        "width=700,height=500"
      );
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    }*/
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const showBetDetails = async (row) => {
    openLedgerPopUp(row.id, row.game_type);
  };

  const showDescription = (marketType) => {
    let marketTypeTxt = "";
    if (marketType == 2) {
      marketTypeTxt = "/Bookmaker";
    } else if (marketType == 1) {
      marketTypeTxt = "/Match Odd";
    } else if (marketType == 5) {
      marketTypeTxt = "/Tie";
    } else if (marketType == 6) {
      marketTypeTxt = "/Figure";
    } else if (marketType == 8) {
      marketTypeTxt = "/EvenOdd";
    }

    //return marketTypeTxt;
  };

  const showEventName = (eventTxt) => {
    return eventTxt;
  };

  return (
    <AgentLayout>
      <div class="right-content-wrapper" style={{ background: "transparent" }}>
        <div class="bets-section-wrapper">
          <div class="row">
            <div class="col-12">
              <UserNavigation
                displayUsername={displayUsername}
              ></UserNavigation>
            </div>

            <div
              class="col-12 col-md-12"
              style={{ display: pageLoad ? "" : "none" }}
            >
              <div class="col-12">
                <div class="row" style={{ marginBottom: "-1.8rem" }}>
                  <div class="col-12 col-md-12">
                    <div class="card">
                      <div class="card-header site_family">
                        <i class="fa fa-align-justify"></i> Report Filter{" "}
                      </div>
                      <div class="card-body">
                        <form
                          id="ReportFilterForm"
                          class="form-inline"
                          method="get"
                        >
                          <div
                            class="row"
                            style={{ textAlignLast: "justify", padding: "7px" }}
                          >
                            <div class="col-12 col-md-5">
                              <div class="form-group">
                                {/*<DatePickerComponent
                                  defaultDate={startDate}
                                  setSelectedDate={startDateSet}
                                />*/}

                                <Bootstrap4DatePickerComponent
                                  pickerId="ReportFrom"
                                  inputId="DisplayFrom"
                                  defaultDate={startDate}
                                  setSelectedDate={startDateSet}
                                />
                              </div>
                            </div>
                            <strong style={{ margin: "auto" }}>
                              &nbsp;-&nbsp;
                            </strong>
                            <div class="col-12 col-md-5">
                              {/*<DatePickerComponent
                                defaultDate={endDate}
                                setSelectedDate={endDateSet}
                              />*/}

                              <Bootstrap4DatePickerComponent
                                pickerId="ReportTo"
                                inputId="DisplayTo"
                                defaultDate={endDate}
                                setSelectedDate={endDateSet}
                              />
                            </div>
                            <div
                              class="form-group editsbmtbtn"
                              style={{
                                width: isMobile ? "100%" : "auto",
                                marginTop: isMobile ? "10px" : ""
                              }}
                            >
                              <label class="mx-1"></label>
                              <button
                                className="btn btn-primary"
                                style={{
                                  background: "#02b181",
                                  border: "none",
                                  padding: "0.375rem 0.85rem",
                                  float: isMobile ? "right" : "unset",
                                  marginRight: isMobile ? "15px" : "unset"
                                }}
                                type="button"
                                onClick={() => getProfitLoss(userId)}
                              >
                                <strong className="site_family">Submit</strong>
                              </button>
                            </div>
                          </div>
                          <div class="row col-12"></div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div
                  class="card"
                  style={{
                    marginTop: "10px",
                    background: "transparent",
                    border: "none"
                  }}
                >
                  <div class="card-bodyx">
                    <div className="table-wrap" id="sportspl">
                      <div
                        className="card"
                        style={{ display: displayPlPanel ? "" : "none" }}
                      >
                        <div className="card-header site_family">
                          <i className="fa fa-align-justify"></i> Sports
                          ProfitLoss <b>({displayUsername}) </b>
                        </div>

                        <div className="card-body" style={{ padding: "7px" }}>
                          <ul className="nav nav-pills">
                            <li
                              className="nav-item site_family"
                              style={{ display: cricektPL != 0 ? "" : "none" }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL"
                                onClick={() => getSportDetail(1, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "0px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Cricket (
                                <span
                                  style={{
                                    color: cricektPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(cricektPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item site_family"
                              style={{ display: fancyPL != 0 ? "" : "none" }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(1, 3, userId)}
                                style={{
                                  color: "#00b181",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Fancy (
                                <span
                                  style={{
                                    color: fancyPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(fancyPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{ display: soccerPL != 0 ? "" : "none" }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(2, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Soccer (
                                <span
                                  style={{
                                    color: soccerPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(soccerPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{ display: tennisPL != 0 ? "" : "none" }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(3, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Tennis (
                                <span
                                  style={{
                                    color: tennisPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(tennisPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{
                                display: horseRacePL != 0 ? "" : "none"
                              }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(4, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Horse Race (
                                <span
                                  style={{
                                    color: horseRacePL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(horseRacePL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{
                                marginLeft: "10px",
                                display: grayHoundPL != 0 ? "" : "none"
                              }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(5, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Greyhound Race (
                                <span
                                  style={{
                                    color: grayHoundPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(grayHoundPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{
                                display: worldCasinoPL != 0 ? "" : "none"
                              }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(6, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Casino (
                                <span
                                  style={{
                                    color: worldCasinoPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(worldCasinoPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{ display: tpStudioPL != 0 ? "" : "none" }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(7, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                TeenPatti Studio (
                                <span
                                  style={{
                                    color: tpStudioPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(tpStudioPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{
                                display: betfairGamesPL != 0 ? "" : "none"
                              }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(9, 1, userId)}
                                style={{
                                  color: "#44bc92",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Betfair Studio (
                                <span
                                  style={{
                                    color:
                                      betfairGamesPL > 0 ? "#44bc92" : "red"
                                  }}
                                >
                                  {formatTruncate(betfairGamesPL)}
                                </span>
                                )
                              </a>
                            </li>

                            <li
                              className="nav-item"
                              style={{
                                display: galexyStudioPL != 0 ? "" : "none"
                              }}
                            >
                              <a
                                className="nav-link Report-EventTypeId-new-frontPL site_family"
                                onClick={() => getSportDetail(10, 1, userId)}
                                style={{
                                  color: "#00b181",
                                  cursor: "pointer",
                                  paddingLeft: "15px",
                                  fontSize: "1rem",
                                  fontWeight: "600"
                                }}
                              >
                                Galaxy Studio (
                                <span
                                  style={{
                                    color:
                                      galexyStudioPL > 0 ? "#00b181" : "red"
                                  }}
                                >
                                  {formatTruncate(galexyStudioPL)}
                                </span>
                                )
                              </a>
                            </li>
                          </ul>

                          <div style={{ overflowY: "auto", width: "100%" }}>
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "right",
                                      fontSize: "20px",
                                      fontWeight: "normal"
                                    }}
                                  >
                                    <div
                                      style={{ fontWeight: "normal" }}
                                      className="site_family"
                                    >
                                      Total Amount :{" "}
                                      <span
                                        style={{
                                          color:
                                            grandTotalPL > 0 ? "#02b180" : "red"
                                        }}
                                      >
                                        {formatTruncate(grandTotalPL)}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div
                        className="row"
                        style={{ display: displayDetailsPanel ? "" : "none" }}
                      >
                        <div className="col-md-12">
                          <div className="card">
                            <div className="card-header site_family">
                              <i className="fa fa-align-justify"></i>
                              Account Ledger
                            </div>

                            <div
                              className="card-body"
                              style={{ padding: "4px" }}
                            >
                              <div className="row">
                                <div className="col-sm-12">
                                  <div class="table-responsive">
                                    <table
                                      id="tableLedger"
                                      class="table table-striped"
                                      role="grid"
                                      aria-describedby="tableLedger_info"
                                    >
                                      <thead style={{ font: "caption" }}>
                                        <tr
                                          role="row"
                                          style={{ backgroundColor: "#fff" }}
                                        >
                                          <th
                                            className="sorting site_family"
                                            tabindex="0"
                                            aria-controls="tableLedger"
                                            rowspan="1"
                                            colspan="1"
                                            aria-label="Match name: activate to sort column ascending"
                                            style={{
                                              width: isMobile ? "80px" : "170px"
                                            }}
                                          >
                                            Date
                                          </th>

                                          <th
                                            className="sorting site_family"
                                            aria-controls="tableLedger"
                                            tabindex="0"
                                            rowspan="1"
                                            colspan="1"
                                            aria-label="Market Name: activate to sort column ascending"
                                          >
                                            {displayEventName}
                                          </th>

                                          <th
                                            className="sorting site_family"
                                            aria-controls="tableLedger"
                                            tabindex="0"
                                            rowspan="1"
                                            colspan="1"
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody
                                        style={{ backgroundColor: "#fff;" }}
                                      >
                                        {profitLossList.map((item, idx) => (
                                          <tr
                                            role="row"
                                            className="even site_family"
                                            style={{
                                              backgroundColor:
                                                idx % 2 == 0
                                                  ? "#f2f2f2"
                                                  : "#ffffff"
                                            }}
                                          >
                                            <td
                                              style={{
                                                fontSize: "15px",
                                                width: "15%"
                                              }}
                                            >
                                              <span className="site_family">
                                                {moment
                                                  .utc(item.created_date)
                                                  .local()
                                                  .format("DD/MM/YYYY hh:mm A")}
                                              </span>
                                            </td>

                                            <td>
                                              <a
                                                onClick={() =>
                                                  showBetDetails(item)
                                                }
                                                className="site_family link_css"
                                                style={{ color: "#04b181" }}
                                              >
                                                {showEventName(item.event_name)}{" "}
                                                {showDescription(
                                                  item.market_type
                                                )}
                                              </a>{" "}
                                            </td>
                                            <td
                                              style={{ fontSize: "15px" }}
                                              className="site_family"
                                            >
                                              {formatTruncate(item.amount)}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                textAlign: "center",
                display: pageLoad ? "none" : "block"
              }}
            >
              <img src="../../assets/images/loadinggif.gif" alt="Loader" />
            </div>
            <style>{`
              .link_css {
                color: #04b181;
                text-decoration: none;
                font-size:15px; 
                cursor: pointer;
                white-space: pre-line;
                word-wrap:anywhere
              }
              
            .toggle-row {
          border: none;
          outline: none;
          cursor: pointer;
          width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-weight: 700;
          font-size: 16px;
          color: #fff;
          background-color: #28a745;
          margin-right: 6px;
        }

        .toggle-open { background-color: #dc3545 !important; }

             table.dataTable > tbody > tr > th, table.dataTable > tbody > tr > td {
              padding: 6px 9px;
          }`}</style>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default AccountProfitLoss;